module.exports = __webpack_public_path__ + "static/media/EL-Logo.f03176a9.png";